import React from "react";
import dayjs from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";

// component
import { Provider } from "react-redux";
import AppRoutes from "./AppRoutes";
import ToasterComponent from "./Components/UI/toaster";
import ErrorBoundary from "./Components/Common/ErrorBoundary";

// redux
import store from "./Store/store";

// helper

// css
import "react-toastify/dist/ReactToastify.css";
import "./Assets/Css/tokens.css";
import "./Assets/Css/Button.css";
import "./Assets/Css/Modals.css";
import "./Assets/Css/Drawers.css";
import "./Assets/Css/CollapseTable.css";
import "./Assets/Css/Checkbox.css";
import "./Assets/Css/style.css";
import "./Assets/Css/custom-new-style.css";

dayjs.extend(updateLocale);
dayjs.updateLocale("en", {
  weekStart: 1});

dayjs.updateLocale("de", {
  monthsShort: [
    "Jan",
    "Feb",
    "März",
    "Apr",
    "Mai",
    "Juni",
    "Juli",
    "Aug",
    "Sept",
    "Okt",
    "Nov",
    "Dez",
  ]});

const App = () => {
  if (window !== window.top) {
    if (window.top) window.top.location = window.location;
  }

  // Clear legacy auth tokens that may still exist in users' browsers
  // from before the HttpOnly cookie migration.
  localStorage.removeItem("token");
  localStorage.removeItem("access");
  localStorage.removeItem("refresh");

  return (
    <div>
      <Provider store={store}>
        <ErrorBoundary>
          <AppRoutes />
          <ToasterComponent />
        </ErrorBoundary>
      </Provider>
    </div>
  );
}

export default App;
